export const selectVisitorType = (state) => state.visitorTypeTable.visitortable;
